import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'number-71-small', 'IconNumber71Small', [["path",{"d":"M15 8h1v8","key":"svg-0"}],["path",{"d":"M7 8h4l-2 8","key":"svg-1"}]]);